import React from 'react';
import { DialogContent } from '@material-ui/core';
import { Warning } from 'phosphor-react';

import * as S from './styles';

interface ErrorDialogProps {
  open: boolean;
  message: string;
  onClose(): void;
}

export function ErrorDialog({ open, message, onClose }: ErrorDialogProps) {
  return (
    <S.Container
      open={open}
      onClose={onClose}
      aria-labelledby="api-error-dialog-title"
    >
      <S.Title id="api-error-dialog-title">
        <S.TitleContent>
          <Warning size={22} color="#d97706" weight="duotone" />
          <span>Sistema temporariamente indisponível</span>
        </S.TitleContent>
      </S.Title>

      <DialogContent>
        <S.Message>{message}</S.Message>
      </DialogContent>

      <S.Actions>
        <S.CloseButton onClick={onClose} variant="contained">
          Fechar
        </S.CloseButton>
      </S.Actions>
    </S.Container>
  );
}
